import { useEffect, useState } from "react";
import { format } from "date-fns";
import axiosInstance from "../../api/axiosInstance";
import Loader from "../../common/Loader";

const FabricatorReport = () => {
  const today = format(new Date(), "yyyy-MM-dd");
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-12-31");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("Report/GetAllByFabricator", {
        fromDate,
        toDate,
      });
      setReportData(response.data);
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-4">
        Febricator Report
      </h2>

      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-6">
        <div>
          <label className="text-sm text-gray-600 font-medium">From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div>
          <label className="text-sm text-gray-600 font-medium">To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-full px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div className="self-end">
          <button
            onClick={fetchReport}
            className="bg-secondary text-white px-5 py-2 rounded-md hover:bg-secondary-dark transition"
          >
            Search
          </button>
        </div>
      </div>

      {/* Report Table */}
      {loading ? (
        <Loader />
      ) : (
        <div className="overflow-x-auto border rounded">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-primary text-white">
              <tr>
                <th className="px-4 py-2 text-left">Febrricator Name</th>
                <th className="px-4 py-2 text-left">Contact No</th>
                <th className="px-4 py-2 text-left">Email</th>
                <th className="px-4 py-2 text-left">Firm Name</th>
                <th className="px-4 py-2 text-left">Office Address</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {reportData.length > 0 ? (
                reportData.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 ">{item.fabricator_Name}</td>
                    <td className="px-4 py-2 ">{item.contact_No}</td>
                    <td className="px-4 py-2 ">{item.email_ID}</td>
                    <td className="px-4 py-2 ">{item.firm_Name}</td>
                    <td className="px-4 py-2 ">{item.office_Address}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center text-gray-500 py-4 font-medium"
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FabricatorReport;
